import { Component, Input, OnInit } from '@angular/core';
import { IUITKSelectItemProps } from '@uitk/angular';
import { OrderNoteDto } from '../../../../dtos/order-note-dto.model';
import { RemoveHoldDto } from '../../../../dtos/remove-hold-dto';
import { ConfigService } from '../../../../services/config.service';
import { OrderService } from '../../../../services/order.service';
import { WorklistQueueService } from '../../../../services/worklistqueue-service';
import { SwalAlert } from '../../../../helpers/alert';
import { AuthorizationService } from 'src/app/services/authorization.service';

@Component({
  selector: 'app-remove-hold',
  templateUrl: './remove-hold.component.html',
  styleUrls: ['./remove-hold.component.css']
})

export class RemoveHoldComponent implements OnInit {
  @Input() dialog = { show: false };
  holdReason: IUITKSelectItemProps | undefined;
  holdReasonPickList: IUITKSelectItemProps[] = [];
  noteText = '';
  swalAlert = new SwalAlert();

  constructor(
    private readonly worklistQueueService: WorklistQueueService,
    private readonly orderService: OrderService,
    private readonly configService: ConfigService,
    private readonly authorizationService: AuthorizationService
  ) {
  }

  ngOnInit(): void {    
    this.holdReasonPickList = this.configService.getPickList("RELHREASON");
  }

  removeHold(): void {
    const currentUser = this.authorizationService.getMyMSId();
    const orderNoteDto = new OrderNoteDto();
    orderNoteDto.noteText = this.holdReason?.label + (this.noteText?('- ' + this.noteText):"");
    orderNoteDto.createdDate = new Date();
    orderNoteDto.userCode =  this.configService.user.salesId;
    orderNoteDto.userName = this.configService.user.fullName;

    const removeHoldDto = new RemoveHoldDto();
    removeHoldDto.orderNoteDto = orderNoteDto;
    removeHoldDto.orderIds.push(this.orderService.orderDto.id);

    this.worklistQueueService.saveRemoveHoldReason(removeHoldDto, currentUser).subscribe(() => {
      this.swalAlert.alert('Hold removed successfully.');
      this.orderService.orderDto.orderStatus = ' ';
      this.orderService.orderDto.holdReasonCode = null;
      this.orderService.recalculateFields(this.orderService.orderDto);
    }, () => {
      this.swalAlert.alert('Hold failed to remove.');
    });

    this.dialog.show = false;
  }
}
